import type { FirmLogoFillItem } from "../../../api/firmLogoFill.service.js";

const PICKABLE_REASON = "profile-logo-clash";

export function isPickableItem(item: FirmLogoFillItem): boolean {
  return item.reason === PICKABLE_REASON && item.candidates.length > 0;
}

export function rowKeyOf(item: FirmLogoFillItem): string {
  return [item.companyId, item.website, item.countryId ?? "firm-wide"].join("-");
}

export function logoSetIdOf(item: FirmLogoFillItem): string {
  return `firm-logo-set-${rowKeyOf(item)}`;
}
